export default __webpack_public_path__ + "static/media/logo-long.9774bbad.png";